import { QRCodeSVG } from "qrcode.react";
import { Camera } from "lucide-react";
import { imageBaseUrl } from '../../utils/utils';
import { useEffect, useState } from "react";
import fetcher from "../../helper/fetcher";
import { useParams } from "react-router-dom";
import { useQrAuth } from "../../context/QrAuth";
 
export default function ContactQR() {
  const [userData, setUserData] = useState({});
  const {user, setUser} = useQrAuth()
  const [data , setData] = useState({})
  const {userId} = useParams()

  useEffect(() => {
    fetcher.get(`/qr/auth/get_userById/${userId}`)
      .then((res) => {
        setData(res?.data?.data)
        // setUserData(`http://localhost:3000/contact-card/contact?id=${userId}`)
        setUserData(`https://www.jinraitech.com/contact-card/contact/${userId}`)
      })
      .catch((error) => {
        // console.log("qr error ==>>", error)
        // showError(error.response?.data?.message || "Internal server Error");
      })
  }, [])

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white p-6 mt-12">
      {/* Card */}
      <div className="relative bg-gradient-to-br from-[#bf98ce] to-[#8f77c6] rounded-2xl shadow-lg text-center w-full max-w-sm pt-16 pb-8 px-6">

        {/* Profile Image with camera icon */}
        <div className="absolute -top-14 left-1/2 transform -translate-x-1/2">
          <div className="relative">
            <img
              src={
                data?.profile_image?.startsWith("https")
                  ? data?.profile_image
                  : imageBaseUrl + "images/"+`${data?.profile_image}`
              }
              alt="profile"
              className="w-28 h-28 rounded-full border-4 border-white shadow-md object-cover"
            />
            <div className="absolute bottom-1 right-1 bg-white rounded-full p-1 shadow">
              <Camera size={16} className="text-gray-600" />
            </div>
          </div>
        </div>

        {/* Name + subtitle */}
        <h2 className="mt-6 text-xl font-bold text-white">{data?.name}</h2>
        <p className="text-sm text-white/80 mb-6">Scan My Contact Number</p>

        {/* QR Code box */}
        <div className="bg-white rounded-xl p-4 shadow-md inline-block ">
          <QRCodeSVG value={userData} size={200} />
        </div>
      </div>

      {/* Bottom Button */}
      <button className="mt-8 w-full max-w-sm py-3 bg-[#7f6bc6] text-white rounded-xl shadow-md hover:opacity-90 transition font-bold">
        scan code
      </button>
    </div>
  );
}
